import React from 'react'

import { MAX_FILE_SIZE, SUPPORTED_FORMATS } from '@/features/FileManager/fileManagerSlice'

export function handleAddDocument(
  event: React.ChangeEvent<HTMLInputElement> | ClipboardEvent,
  setDocuments: React.Dispatch<React.SetStateAction<any[]>>,
  isPDFOnly: boolean
) {
  const getFiles = (event) => {
    if ((event as ClipboardEvent)?.clipboardData?.files) {
      return event.clipboardData.files
    }
    return event.target.files
  }

  const fileObject = getFiles(event)

  if (
    fileObject.length &&
    (isPDFOnly
      ? fileObject[0]?.type == 'application/pdf'
      : SUPPORTED_FORMATS.includes(fileObject[0]?.type)) &&
    fileObject[0]?.size < MAX_FILE_SIZE
  ) {
    const reader = new FileReader()
    reader.readAsDataURL(fileObject[0])
    reader.onload = (e) => {
      const documentTemp = {
        document: fileObject[0],
        content: e.target.result,
      }
      setDocuments((values) => [...values, documentTemp])
    }
  }
}
